const getters = {
  sidebar: (state) => state.app.sidebar,
  // routeState: (state) => state.app.routeState,
  device: (state) => state.app.device,
  token: (state) => state.user.token,
  avatar: (state) => state.user.avatar,
  name: (state) => state.user.name,
  role: (state) => state.user.role,
  userid: (state) => state.user.userid,
  devices: (state) => state.user.devices,
  routes: (state) => state.user.routes,

  // device
  bpInfos: (state) => state.device.bpInfos,
  // history data
  tableColumns: (state) => state.historyData.tableColumns,
  historyData: (state) => state.historyData.historyData,
  total: (state) => state.historyData.total,
  // real time data
  gaugeData: (state) => state.realTimeData.gaugeData,
  // state data
  stateData: (state) => state.stateData.stateData
}
export default getters
